/**
 * About component
 *
 * Space for you to describe more about yourself.
 */

import React from "react";

/**
 * About background image
 *
 * Below is a sample image. Upload the image of your choice into the "images"
 * directory and import here for use. Then, set imageAltText to string that
 * represents what you see in that image.
 *
 * Need an image? Check out https://unsplash.com to download a image you
 * freely use on your site.
 */
import image from "../images/motion-background.jpg";

const imageAltText = "purple and blue abstract background";

/**
 * Sort description that expands on your title on the Home component.
 */
const description =
  "I am a Statistics student at the Universidad Nacional de Colombia and an Economics student at the Universidad de Antioquia. I enjoy creating innovative solutions for complex problems. Some of my areas of interest are:";

/**
 * List of some of skills or technologies you work on, are learning,
 * passionate about, or enjoy,
 */
const skillsList = [
  "Data processing",
  "Predictive modeling",
  "Data visualization",
  "Econometrics",
  "Spatial statistics",
  "Bayesian analysis",
];

/**
 * Use this to give more information about what you are passionate about,
 * how you best work, or even a quote. This will help someone learn more
 * about you on a professional level.
 */
const detailOrQuote =
  "I am passionate about data science and programming to solve problems in innovative and creative ways. I am always looking for new and better ways to use technology for the benefit of everyone.";

const About = () => {
  return (
    <section className="padding" id="about">
      <img className="background2" src={image} alt={imageAltText} />
      <div
        style={{
          backgroundColor: "white",
          width: "70%",
          padding: "5%",
          margin: "2rem auto",
          textAlign: "center",
        }}
      >
        <h2>About Myself</h2>
        <p className="Medium">{description}</p>
        <hr />
        <ul>
          {skillsList.map((skill) => (
            <li key={skill}>{skill}</li>
          ))}
        </ul>
        <hr />
        <p className="medium">{detailOrQuote}</p>
      </div>
    </section>
  );
};

export default About;
